export type  UserTheme = 'lifeislife' | 'luna_blue';
export const ALL_USER_THEMES: UserTheme[] = [
  'lifeislife',
  'luna_blue',
];
